import type { BeneficiaryAccessPayload } from '@Application/Beneficiaries/Access/Actions/beneficiaryAccessFetched';

/** The caller's level on the beneficiary dossier type: `null` means no access at all. */
class BeneficiaryAccessView {
	readonly accountId: number;
	readonly level: 'use' | 'supervise' | null;
	readonly canRead: boolean;
	readonly canSupervise: boolean;

	constructor(payload: BeneficiaryAccessPayload) {
		this.accountId = payload.accountId;
		this.level = payload.level?.value ?? null;
		this.canRead = this.level !== null;
		this.canSupervise = this.level === 'supervise';

		Object.freeze(this);
	}
}

export default BeneficiaryAccessView;
